import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  saveVideoProgress,
  saveQuizProgress,  
  saveUserProfileStatus,
  updateUserProfileFields,
} from "./userApi";

const initialState = {
  status: "idle"  
};

export const setUserAsync = createAsyncThunk(
  "user/setUserAsync",
  async (payload) => {
    return payload;
  }
);

export const clearUserAsync = createAsyncThunk(
  "user/clearUserAsync",
  async () => {
    return;
  }
);

export const saveVideoProgressAsync = createAsyncThunk(
  "user/saveVideoProgressAsync",
  async ({ db, user, video, learningPath, progress }) => {
    await saveVideoProgress({ db, user, video, learningPath, progress });
    return;
  }
);

export const saveQuizProgressAsync = createAsyncThunk(
  "user/saveQuizProgressAsync",
  async ({ db, user, progress }) => {
    await saveQuizProgress({ db, user, progress });
    return;
  }
);

export const saveUserProfileStatusAsync = createAsyncThunk(
  "user/saveUserProfileStatusAsync",
  async ({ db, user, isProfileComplete }) => {
    await saveUserProfileStatus({ db, user, isProfileComplete });
    return { isProfileComplete };
  }
);

export const updateUserProfileFieldsAsync = createAsyncThunk(
  "user/updateUserProfileFieldsAsync",
  async ({ db, user, userProfilefields }) => {
    const updateUserProfile = await updateUserProfileFields({
      db,
      user,
      userProfilefields,
    });
    return updateUserProfile;
  }
);

export const setShouldDisplayProfileAsync = createAsyncThunk(
  "user/setShouldDisplayProfileAsync",
  async (value) => {
    return value;
  }
);

export const setIsLoadingProfileDataAsync = createAsyncThunk(
  "user/setIsLoadingProfileDataAsync",
  async (value) => {
    return value;
  }
);

export const setNotificationMessageSentAsync = createAsyncThunk(
  "user/setNotificationMessageSentAsync",
  async (value) => {
    return value;
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setUserAsync.pending, (state) => {                
        state.status = "loading"
      })
      .addCase(setUserAsync.fulfilled, (state, action) => {                                
        if (action && action.payload) {
          for (const key in action.payload) {
            if (action.payload.hasOwnProperty(key)) {
              state[key] = action.payload[key];
            }
          }
        }              
        
        state.status = `idle`;
      })
      .addCase(clearUserAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(clearUserAsync.fulfilled, (state) => {                        
        state.profile = undefined;
        state.isProfileComplete = undefined;
        state.shouldDisplayProfile = undefined;
        state.status = "idle";
      })
      .addCase(saveVideoProgressAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(saveVideoProgressAsync.fulfilled, (state) => {
        state.status = `idle`;
      })
      .addCase(saveUserProfileStatusAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(saveUserProfileStatusAsync.fulfilled, (state, action) => {
        state.isProfileComplete = action.payload.isProfileComplete;
        state.status = `idle`;
      })
      .addCase(updateUserProfileFieldsAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(updateUserProfileFieldsAsync.fulfilled, (state, action) => {
        let profile = { ...state.profile };

        if (action.payload) {
          Object.keys(action.payload).forEach((key) => {
            profile[key] = action.payload[key];
          });
        }

        state.profile = profile;
        state.status = `idle`;
      })
      .addCase(saveQuizProgressAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(saveQuizProgressAsync.fulfilled, (state) => {
        state.status = `idle`;
      })
      .addCase(setShouldDisplayProfileAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setShouldDisplayProfileAsync.fulfilled, (state, action) => {
        state.shouldDisplayProfile = action.payload;
        state.status = `idle`;
      })
      .addCase(setIsLoadingProfileDataAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setIsLoadingProfileDataAsync.fulfilled, (state, action) => {
        state.isLoadingProfileData = action.payload;
        state.status = `idle`;
      })
      .addCase(setNotificationMessageSentAsync.pending, (state) => {
        state.status = `loading`;
      })
      .addCase(setNotificationMessageSentAsync.fulfilled, (state, action) => {
        state[`sentPrizeNotificationFor${action.payload}`] = true;
        state.status = `idle`;
      })
    },
});

export default userSlice.reducer;
